// Equalize CarouselCard heights within the Landing Page Carousel section only (Flickity does not stretch cells to match siblings)
function equalizeCarouselCardHeights() {
  $('.LandingPageCarousel .ProductList--carousel').each(function() {
    var $cards = $(this).find('.CarouselCard');
    $cards.css('height', 'auto');
    var tallest = -1;
    $cards.each(function() {
      var height = $(this).outerHeight();
      tallest = height > tallest ? height : tallest;
    });
    $cards.css('height', tallest);
  });
}

$(window).on('load resize', equalizeCarouselCardHeights);
$(document).on('lazyloaded', '.LandingPageCarousel .CarouselCard img', equalizeCarouselCardHeights);
